import { fontWeightOptions } from "../../../constants";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../ui/select";
import { getPreloadedFontsMenuOptions } from "../../../constants/fonts";
import { Input } from "../../ui/input";

const selectConfigs = [
  {
    property: "fontFamily",
    placeholder: "Choose a font",
    options: getPreloadedFontsMenuOptions(),
  },
  {
    property: "fontWeight",
    placeholder: "Semibold",
    options: fontWeightOptions,
  },
];

type TextProps = {
  fontFamily: string;
  fontSize: number;
  fontWeight: string;
  elementAttributes: any;
  handleInputChange: (property: string, value: string) => void;
};

const Text = ({
  fontFamily,
  fontSize,
  fontWeight,
  handleInputChange,
  elementAttributes,
}: TextProps) => {
  return (
    <div className="flex flex-col gap-3 border-b border-borderColor px-2 py-5">
      <h3 className="text-[10px] uppercase px-1">Text Settings</h3>

      <div className="flex flex-col gap-3">
        {RenderSelect({
          config: selectConfigs[0],
          fontSize,
          fontWeight,
          fontFamily,
          handleInputChange,
        })}

        <div className="flex gap-2">
          <div className="flex items-center  rounded-sm">
            <Input
              type="number"
              id={"fontSize"}
              placeholder={"32"}
              value={elementAttributes.fontSize || 0}
              className="input-ring bg-transparent text-white placeholder"
              onChange={(e) => handleInputChange("fontSize", e.target.value)}
              min={0}
            />
          </div>

          {selectConfigs.slice(1).map((config) =>
            RenderSelect({
              config,
              fontSize,
              fontWeight,
              fontFamily,
              handleInputChange,
            })
          )}
        </div>
      </div>
    </div>
  );
};

type Props = {
  config: {
    property: string;
    placeholder: string;
    options: { label: string; value: string }[];
  };
  fontSize: number;
  fontWeight: string;
  fontFamily: string;
  handleInputChange: (property: string, value: string) => void;
};

const RenderSelect = ({
  config,
  fontSize,
  fontWeight,
  fontFamily,
  handleInputChange,
}: Props) => (
  <Select
    key={config.property}
    onValueChange={(value) => handleInputChange(config.property, value)}
    value={
      config.property === "fontFamily"
        ? fontFamily
        : config.property === "fontSize"
        ? String(fontSize)
        : fontWeight
    }
  >
    <SelectTrigger
      style={{
        fontFamily: config.property === "fontFamily" ? fontFamily : undefined,
      }}
      className="px-2 text-truncate text-start no-ring w-full rounded-lg border border-grey-200 text-white"
    >
      <SelectValue
        placeholder={
          config.property === "fontFamily"
            ? "Choose a font"
            : config.property === "fontSize"
            ? "36"
            : "Semibold"
        }
      />
    </SelectTrigger>
    <SelectContent className="border-grey-200 bg-black text-grey-300">
      {config.options.map((option) => (
        <SelectItem
          key={option.value}
          value={option.value}
          className="text-white  hover:bg-primary hover:cursor-pointer"
          style={{
            fontFamily:
              config.property === "fontFamily" ? option.value : undefined,
          }}
        >
          {option.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export default Text;
